<template>
  <div style="height: 100vh;">
    <b-navbar :sticky="true" toggleable class="navbar navbar-expand-xl">
      <b-navbar-brand href="#">
          <img id="um-logo" src="@/assets/images/cover-icon-square.svg">
      </b-navbar-brand>
          <button v-b-toggle.sidebar-right id="hamburger" class="btn btn-outline-dark btn-close"> <span class="navbar-toggler-icon"></span> </button>
    </b-navbar>

    <div>
      <b-sidebar id="sidebar-right" title="" right shadow @hidden="hideLanguageBar">
        <div class="px-3 py-2">
          <div v-if="this.$i18n.i18next.language === 'es'" id="understanding-es">{{ $t('understanding')}}</div>
          <div v-if="this.$i18n.i18next.language === 'en'" id="understanding">{{ $t('understanding')}}</div>
          <div id="mezcal">{{ $t('mezcal')}}</div>
          <ul>
            <router-link v-b-toggle.sidebar-right to="/maps">{{ $t('mezcalMaps')}}</router-link> 
            <router-link v-b-toggle.sidebar-right to="/agave">{{ $t('agaveSearch')}}</router-link>
            <router-link v-b-toggle.sidebar-right to="/producer">{{ $t('producerSearch')}}</router-link>
            <router-link v-b-toggle.sidebar-right to="/about">{{ $t('about')}}</router-link>
          </ul>
        </div>
        <div id="language-select">
          <div id="spanish-container" @click.prevent="selectLanguage('es')" :class="{ expanded: languageExpanded, 'selected': languageSelected === 'es' }">
            <div class="container-content">
              <span class="language-label">Español/Spanish </span>
              <img id="spain-flag" class="country-flag" src="@/assets/images/spain-flag.svg">
            </div>
          </div>
          <div id="english-container" @click.prevent="selectLanguage('en')" :class="{ expanded: languageExpanded, 'selected': languageSelected === 'en' }">
            <div class="container-content">
              <span class="language-label">English/Inglés </span>
              <img id="uk-flag" class="country-flag" src="@/assets/images/united-kingdom-flag.svg">
            </div>
          </div>
        </div>
      </b-sidebar>
    </div>
    <router-view/>
  </div>
</template>

<script>

/* eslint-disable */

import {
  producers,
  towns,
  stills,
  fermenters,
  brands,
  municipalities,
  states,
  brandsToProducers,
  commonNames,
  speciesNames,
  subspeciesNames,
  commonToSpecies
} from '@/assets/JSON/data.js'


export default {
  name: 'App',
  components: {

  },
  data() {
      return {
        languageExpanded: false,
        languageSelected: 'en',
        isReady: false,
        currentLocation: {},
    }
  },
  mounted() {
    // try{
    //   let newScript = document.createElement('script');
    //   let scriptUrl = '@/assets/JSON/um-demo-data.js'

    //   newScript.setAttribute('src', scriptUrl);
    //   document.head.appendChild(newScript);
    // } catch (error) {
    //   console.log(error);
    // }

    document.addEventListener('deviceready', this.onDeviceReady);

    if (localStorage.route === undefined || localStorage.route === 'null'){
      this.$router.push('Maps');
    } else {
      this.$router.push(localStorage.route);
    }

    let loadTimer = setTimeout(this.setupData, 1000);



  },
  methods: {
    async setupData(){




          this.$setItem('versionNumber', '1.0.0 offline');
          this.$setItem('brands', brands);
          this.$setItem('brandsToProducers', brandsToProducers);
          this.$setItem('commonNames', commonNames);
          this.$setItem('commonToSpecies', commonToSpecies);
          this.$setItem('fermenters', fermenters);
          this.$setItem('municipalities', municipalities);
          this.$setItem('producers', producers);
          this.$setItem('speciesNames', speciesNames);
          this.$setItem('states', states);
          this.$setItem('stills', stills);
          this.$setItem('subspeciesNames', subspeciesNames);
          this.$setItem('towns', towns);



    },
    selectLanguage(language){
      if (this.languageExpanded === false){
        this.languageExpanded = true;
        
      } else {
        this.languageSelected = language;
        this.$i18n.i18next.changeLanguage(language);
        this.languageExpanded = false;
        this.$router.push({ name: 'About', params: { nocache: new Date().toString() }});
      }

      
    },
    hideLanguageBar(){
      this.languageExpanded = false;
    },
    onDeviceReady(event){
      this.isReady = true;
      navigator.geolocation.getCurrentPosition(this.setUserPosition, this.positionError, {timeout: 3000})
    },
    setUserPosition(position){
      this.$store.commit("changeUserPosition", position);
    },
    positionError(error){
      console.log(error);
    }
  },

  watch: {
    $route(newValue){
      localStorage.route = newValue.name
    }
  }
}

</script>

<style lang="scss">
@import './assets/scss/custom.scss';

body {
  font-family: 'Avenir';
  user-select: none;
}

ul {
  list-style: none;
}

a, a:link, a:visited, a:hover, a:active {
  color: black;
  text-decoration: none;
  font-size: 24px;
  display: block;
  font-family: 'Avenir';
  line-height: 45px;
}

.offcanvas-header{ 
	display:none;
}

.navbutton-no-outline {
  border: none;
}

.b-sidebar {
  width: 100%;
  background-color: #EBFAF9!important;
}

.close.text-dark {
  color: black !important;
}

.country-flag {
  height: 20px;
  margin-left: 5px;
}

.container-content {
  float: right;
  display: flex;
}


#um-logo {
    box-shadow: 1px 1px 4px 0px rgba(0,0,0,0.3);
    height: 45px;
    width: 45px;
}

#sidebar-header {
  font-weight: 700;
  color: black;
}

#understanding {
  font-family: 'Avenir';
  font-size: 23px;
}

#understanding-es {
  font-family: 'Avenir';
  font-size: 26px;
}

#mezcal {
  font-family: futura;
  font-size: 51px;
  line-height: .8;
  margin-bottom: 25px;
}

#language-select {
  width: 160px;
  position: absolute;
  bottom: 45px;
  right: 15px;
}

#english-container {
  width: 160px;
  height: 25px;
  top: 0;
  position: absolute;
  transition: all 0.25s ease-in-out;
}


#spanish-container {
  width: 160px;
  position: absolute;

  
}

#spanish-container.selected, #english-container.selected {
  background-color: #EBFAF9;
  z-index: 500;
}


#english-container.expanded {
  top: -27px;
}



</style>
